import { render, staticRenderFns } from "./ScanFaceIcon.vue?vue&type=template&id=73051e14"
import script from "./ScanFaceIcon.vue?vue&type=script&lang=js"
export * from "./ScanFaceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports